// @flow
import defaultState from '../defaultState';
import { uniqueById } from '../helpers';
import type { CurrentIndustry as State } from '../types';

const defaultCurrentIndustry = defaultState.currentIndustry;

type UpdateCurrentIndustryAction = {
  type: 'UPDATE_CURRENT_INDUSTRY',
  industry: Object
};
type Action = UpdateCurrentIndustryAction;

export default function currentIndustry(
  state: State = defaultCurrentIndustry,
  action: Action
) {
  switch (action.type) {
    case 'UPDATE_CURRENT_INDUSTRY':
      return {
        ...defaultCurrentIndustry,
        ...action.industry
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_INDUSTRY_ALLOCATED_ORGANISATIONS':
      return {
        ...state,
        organisations: {
          ...state.organisations,
          allocated: action.allocated
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_INDUSTRY_UNALLOCATED_ORGANISATIONS':
      return {
        ...state,
        organisations: {
          ...state.organisations,
          unallocated: action.unallocated
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_INDUSTRY_ALLOCATED_INSIGHTSETS':
      return {
        ...state,
        insightSets: {
          ...state.insightSets,
          allocated: action.insightSets
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_INDUSTRY_UNALLOCATED_INSIGHTSETS':
      return {
        ...state,
        insightSets: {
          ...state.insightSets,
          unallocated: action.insightSets
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_INDUSTRY_ALLOCATED_SHAPESETS':
      return {
        ...state,
        shapeSets: {
          ...state.shapeSets,
          allocated: uniqueById(action.shapeSets)
        }
      };

    // $FlowFixMe
    case 'UPDATE_CURRENT_INDUSTRY_UNALLOCATED_SHAPESETS':
      return {
        ...state,
        shapeSets: {
          ...state.shapeSets,
          unallocated: uniqueById(action.shapeSets)
        }
      };

    // $FlowFixMe
    case 'CLEAR_CURRENT_INDUSTRY':
      return defaultCurrentIndustry;

    // $FlowFixMe
    case 'LOGOUT':
      return defaultCurrentIndustry;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentIndustry.js